import { render } from "./CustomerDetail.vue?vue&type=template&id=45973158"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__